import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/_LOGIC/__config/config.service';
import { ShopifyService } from 'src/app/_LOGIC/__shopify/shopify.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {

  constructor(private router: Router,private shopifyService: ShopifyService,private configService: ConfigService) { }
  
    ngOnInit(): void {
    }
  
    goToPage(page: any) {
      this.router.navigateByUrl(page.path);
    }
  
    goToCalendly(){
      window.open('https://calendly.com/voy-jaleas/30min?month=2023-02', '_blank');
    }

    buyProductSimple(myVariantLabel){
      let orderObject = {
              'productVariantId': this.configService.findVariantBy(this.configService.getStockProductsFromShopify(),'variantLabel', myVariantLabel).variantId
      };
      this.shopifyService.buyProduct(orderObject);
  }
  
  }